import React from 'react';
import { PostHogProvider } from 'posthog-js/react';

/**
 * PostHog solo tras consentimiento (CookieConsentProvider envuelve la app).
 *
 * Región: proyecto US (us.posthog.com). REACT_APP_POSTHOG_HOST debe ser
 * exactamente https://us.i.posthog.com (mismo cloud que la API key).
 *
 * Auditoría SEO sept 2026: el CORS de /flags/ visto en GSC es del renderer
 * de Google contra el dominio de PostHog; no afecta indexación. En navegador
 * real Origin https://trimergy.io recibe Access-Control-Allow-Origin correcto
 * y /flags/ 200 — no hace falta reverse proxy salvo que falle para usuarios.
 */
const PostHogWithConsent = ({ children }) => {
  const posthogEnabled = process.env.REACT_APP_POSTHOG_ENABLED === 'true';
  const posthogRecordingsEnabled = process.env.REACT_APP_POSTHOG_RECORDINGS_ENABLED === 'true';

  if (!posthogEnabled) {
    return children;
  }

  const apiHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
  const posthogOptions = {
    api_host: apiHost,
    // UI host alineado con región US (toolbar / enlaces internos del SDK)
    ui_host: 'https://us.posthog.com',
    defaults: '2025-11-30',
    disable_session_recording: !posthogRecordingsEnabled,
  };

  return (
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
};

export default PostHogWithConsent;
